import { DateConstructable } from '../lib/customType';

export default function calculateBatchProgress(saleClosesOn: DateConstructable, maturesOn: DateConstructable): number {
  const currentTime = new Date();
  const batchStartTime = new Date(saleClosesOn);
  const batchEndTime = new Date(maturesOn);
  return (currentTime.valueOf() - batchStartTime.valueOf()) / (batchEndTime.valueOf() - batchStartTime.valueOf());
}
